
<template>
    <div :class="['modal-container', { 'active': active },]" style="max-width: 100%;">
        <div class="card head-card news">
            <div class="title-card">
                <h4>Elegir Imagen</h4>
                <button class="touchpad" @click="cerrar">x</button>
            </div>
            <div class="card-content">
                <div class="row ">

                    <div class="col-12">
                        <div class="inputype Keywords-input">
                            <form>
                                <h4 class="interiorTitle">Logo</h4>
                                <h5 class="interiorTitle">Formatos aceptados: PNG y JPG, dimensiones máximas: 412 x 128
                                    pixeles.
                                </h5>

                                <input id="logoNewsletter" type="file" accept="image/png, image/jpg, image/jpeg"
                                    placeholder="Logo" @input="uploadImage" />
                            </form>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-12 mt-4 " v-if="url != '' && url != null">
                        <!-- <img :src="url" alt=""> -->
                        <cropper class="cropper" :src="url" ref="cropper" :stencil-props="options" @change="change"
                            :minWidth="412" :maxWidth="412" :minHeight="128" :maxHeight="128" :viewMode="0"
                            :autoCropArea="0.5">
                        </cropper>


                    </div>
                    <div class="col-sm-12 col-md-12 mt-2 mb-2">
                        <div class="Keywords-button-container">

                            <button :class="[
                                    'button',
                                    'fluid',
                                    'alternative',
                                    'noMargin',
                                ]" @click="saveImagen">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
export default {
    components: { Cropper },
    props: ['active', 'cancelar', 'guardar', 'error', 'imagenAnterior'],
    data() {
        return {
            url: "",
            file: null,
            width: 0,
            height: 0,
            options: {
                // aspectRatio: 650 / 200,
                // aspectRatio:3.15,
                fixedBox: true,
                fixedNumber: 0,
                minWidth: 412,
                maxWidth: 412,
                minHeight: 128,
                maxHeight: 128,
                outputType: "png",
                canMove: false,
                canResize: false,
                viewMode: 0,
                dragMode: 'move',
                zoomable: false,
                zoomOnTouch: false,
                zoomOnWheel: false,
                backgroundClass: 'background',
                imageRestriction: 'stencil',
                // minZoom: 0.1,
                full: true,

            },

        }
    },
    mounted() {
        console.log('mounted', this.imagenAnterior);
        if (this.imagenAnterior) {
            this.url = this.imagenAnterior
        }

    },
    unmounted() {
        console.log("destroyed");
        this.url = "";
        this.file = null;
        this.width = 0;
        this.height = 0;
        this.$refs.cropper.reset();
    },
    methods: {
        cerrar() {
            this.url = "";
            this.file = null;
            this.width = 0;
            this.height = 0;
            if (this.$refs.cropper) {
                this.$refs.cropper.reset();
            }
            if (document.getElementById("logoNewsletter")) {
                document.getElementById("logoNewsletter").value = "";
            }

            this.cancelar();
        },
        async uploadImage(event) {
            const imagen = event.target.files[0];

            console.log(event);
            // this.url = imagen;
            this.url = window.URL.createObjectURL(imagen);
            console.log(this.url);
            await this.valildDimensiones(this.url);



            // if (imagen) {
            //     const fileExtension = imagen.name.split(".").pop();
            //     console.log(fileExtension);
            //     // this.file = imagen;
            //     if (fileExtension == "png" || fileExtension == "jpg" || fileExtension == "jpeg") {
            //         const reader = new FileReader();

            //         reader.onload = async () => {
            //             this.url = reader.result;
            //             this.file = btoa(reader.result);
            //             await this.valildDimensiones(this.url);

            //         };

            //         reader.readAsDataURL(imagen);
            //     } else {
            //         document.getElementById("logoNewsletter").value = "";
            //         this.url = null;
            //         this.file = null;
            //         this.error("Solo se admite formato png, jpg y jpeg");
            //     }



            // }


        },
        async valildDimensiones(imagen) {
            console.log("hola we", imagen);
            const img = new Image();
            img.onload = async () => {
                console.log("aqui");
                // await console.log(img.width);
                // img.width > 600 || img.height > 200

                // this.options.aspectRatio = (img.width +10) / (img.height+10)
                console.log(this.options.aspectRatio, "aspectRadios");
            };
            img.src = imagen;


        },

        change({ coordinates, canvas }) {
            console.log(coordinates, canvas);
        },

        saveImagen() {
            if (this.$refs.cropper) {
                const { canvas } = this.$refs.cropper.getResult();

                const dataUrl = canvas.toDataURL("image/jpeg");

                const blob = this.dataURLToBlob(dataUrl);

                const file = new File([blob], "cropped-image.jpg", { type: "image/jpeg" });


                this.guardar(file);


                this.url = "";
                this.file = null;
                this.width = 0;
                this.height = 0;
                if (document.getElementById("logoNewsletter")) {
                    document.getElementById("logoNewsletter").value = "";
                }
                this.$refs.cropper.reset();
            }
        },
        dataURLToBlob(dataUrl) {
            const binary = atob(dataUrl.split(",")[1]);
            const array = [];
            for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
        },

        onZoom(zoom) {
            const cropper = this.$refs.cropper.getResult();
            if (zoom < 1) {
                const minZoom = Math.max(zoom, 0.1); // Establecer el valor mínimo de zoom
                cropper.setOptions({
                    minZoom: minZoom,
                });
            }
        },

    },
    watch: {
        "cropperOptions.zoom": function (zoom) {
            console.log(zoom, "zoom");
            this.onZoom(zoom);
        },
    }
}
</script>

<style>
.cropper {
    height: 100px;
    background: #DDD;
}
</style>